"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  DomrfCalculator: true
};
Object.defineProperty(exports, "DomrfCalculator", {
  enumerable: true,
  get: function () {
    return _AppContainer.AppContainer;
  }
});
var _AppContainer = require("./containers/AppContainer");
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});